import { AppEnv, ReviewerRoute } from './app-config.models';

export const ENV_OVERRIDE_STORAGE_KEY = 'envOverride';

type EnvOverride = Pick<AppEnv, 'configApiBaseUrl' | 'idpBaseUrl'>;

function normalizeEmail(email: string): string {
  return email.trim().toLowerCase();
}

export function findReviewerRoute(
  env: AppEnv,
  email: string,
): ReviewerRoute | null {
  const target = normalizeEmail(email);
  if (!target) {
    return null;
  }
  return (
    env.reviewerRoutes?.find(
      (route) => normalizeEmail(route.email) === target,
    ) ?? null
  );
}

function readEnvOverride(): EnvOverride | null {
  try {
    const raw = localStorage.getItem(ENV_OVERRIDE_STORAGE_KEY);
    if (!raw) {
      return null;
    }
    const parsed = JSON.parse(raw) as Partial<EnvOverride>;
    if (parsed.configApiBaseUrl && parsed.idpBaseUrl) {
      return {
        configApiBaseUrl: parsed.configApiBaseUrl,
        idpBaseUrl: parsed.idpBaseUrl,
      };
    }
    return null;
  } catch {
    return null;
  }
}

export function persistEnvOverride(override: EnvOverride): void {
  try {
    localStorage.setItem(ENV_OVERRIDE_STORAGE_KEY, JSON.stringify(override));
  } catch {
    // Ignore storage failures; the in-memory override still applies.
  }
}

export function resolveAppEnv(base: AppEnv): AppEnv {
  const override = readEnvOverride();
  return override ? { ...base, ...override } : { ...base };
}
